//SECTION CHECKBOX

import { gql, useMutation, useQuery } from "@apollo/client";
import { useFormik } from "formik";
import * as yup from 'yup';
import { addMessage, resetMessage } from "../../../../../stores/ReactiveVariables";
import { AccordionCheckbox } from "../AccordionCheckbox";

const GET_COVER_LETTER_PROJECT_BREAKDOWN_SECTION = gql`
    query GetCoverLetterProjectBreakdown($Id: uniqueidentifier = "") {
        BidQuotes_by_pk(Id: $Id) {
            CoverLetterProjectBreakdownSection
        }
    }  
`;

const UPDATE_COVER_LETTER_PROJECT_BREAKDOWN_SECTION = gql`
    mutation UpdateCoverLetterProjectBreakdownSection($Id: uniqueidentifier = "", $CoverLetterProjectBreakdownSection: Boolean = false) {
        update_BidQuotes_by_pk(pk_columns: {Id: $Id}, _set: {CoverLetterProjectBreakdownSection: $CoverLetterProjectBreakdownSection}) {
            __typename
            Id
        }
    }
`;

interface ProjectBreakdownCheckboxProps {
    id: string;
    getCoverLetter: () => void;
}

const validationSchema = yup.object().shape({
    CoverLetterProjectBreakdownSection: yup.boolean(),
});

export const ProjectBreakdownCheckbox: React.FC<ProjectBreakdownCheckboxProps> = ({ id, getCoverLetter }: ProjectBreakdownCheckboxProps) => {
    const { data, loading, error } = useQuery(GET_COVER_LETTER_PROJECT_BREAKDOWN_SECTION, { variables: { Id: id } });
    const [updateCoverLetterExecutionPlan] = useMutation(UPDATE_COVER_LETTER_PROJECT_BREAKDOWN_SECTION);

    const formData = data?.BidQuotes_by_pk;

    const formik = useFormik({
        enableReinitialize: true,
        validationSchema: validationSchema,
        initialValues: {
            CoverLetterProjectBreakdownSection: formData?.CoverLetterProjectBreakdownSection ?? false,
        },
        onSubmit: (values: any) => {
            updateCoverLetterExecutionPlan({
                variables: { Id: id, CoverLetterProjectBreakdownSection: values.CoverLetterProjectBreakdownSection },
                onCompleted: (data: any) => {
                    resetMessage();
                    const confirmMessage = values.CoverLetterProjectBreakdownSection === true ? "Project Breakdown Added To Cover Letter" : "Project Breakdown Removed From Cover Letter";
                    addMessage(confirmMessage, { severity: 'success' });
                    getCoverLetter();
                },
                onError: () => {
                    addMessage('Error Saving/Removing Project Breakdown', { severity: 'error' });
                }
            });
        }
    });

    return (
        <AccordionCheckbox
            getCoverLetter={getCoverLetter}
            name="CoverLetterProjectBreakdownSection"
            checked={formik.values.CoverLetterProjectBreakdownSection}
            onCheckboxClick={() => formik.setFieldValue('CoverLetterProjectBreakdownSection', !formik.values.CoverLetterProjectBreakdownSection)}
            onSave={formik.submitForm}
            loading={loading}
        />
    )
}
